import type { PlayerAssetStatuses } from '../types';
import { usePlayerStore } from '../store/playerStore';
import { derivePlayerActorAssetStatus } from './usePlayerActorAssetStatus';

export function usePlayerAssetStatus(playerId?: string): PlayerAssetStatuses {
  const store = usePlayerStore();
  const { activeActorId, assetStatusByActorId, actorsById } = store.state;
  const resolvedActorId = playerId ?? activeActorId;
  const actorIds = Object.keys(actorsById);
  const byActorId = Object.fromEntries(
    actorIds.map((actorId) => [
      actorId,
      derivePlayerActorAssetStatus(actorId, assetStatusByActorId[actorId]),
    ]),
  );
  const actorsLoading = actorIds.filter((actorId) => byActorId[actorId].isLoading);
  const actorsReady = actorIds.filter((actorId) => byActorId[actorId].isReady);

  return {
    activeActorId: resolvedActorId ?? null,
    byActorId,
    actorsLoading,
    actorsReady,
    isLoading: actorsLoading.length > 0,
    isReady: actorIds.length > 0 && actorsReady.length === actorIds.length,
  };
}
